import actionTypes from "../actionTypes";


function fetch() {
  return {
    type: actionTypes.paymentMethods.FETCH
  };
}

function fetchOk(data) {
  return {
    type: actionTypes.paymentMethods.FETCH_OK,
    data: data
  };
}

function fetchError(error) {
  return {
    type: actionTypes.paymentMethods.FETCH_ERROR,
    error: error
  };
}

function remove(id) {
  return {
    type: actionTypes.paymentMethods.REMOVE,
    id: id
  };
}

function removeOk(id) {
  return {
    type: actionTypes.paymentMethods.REMOVE_OK,
    id: id
  };
}

function setAsPrimary(id) {
  return {
    type: actionTypes.paymentMethods.SET_AS_PRIMARY,
    id: id
  };
}

function setAsPrimaryOk(id) {
  return {
    type: actionTypes.paymentMethods.SET_AS_PRIMARY_OK,
    id: id
  };
}


function setProcessing(id, value) {
  return {
    type: actionTypes.paymentMethods.SET_PROCESSING,
    id: id,
    value: value
  };
}

export const paymentMethodsActions = {
  fetch,
  fetchOk,
  fetchError,
  remove,
  removeOk,
  setAsPrimary,
  setAsPrimaryOk,
  setProcessing
}